import { Alert } from "~/components/reusable/Alert"

export const OverlapAlertPurchaseOrderCreate = ({
  numberOfVariantsWithSuggestedOrder,
  variantsLength,
}: {
  numberOfVariantsWithSuggestedOrder: number
  variantsLength: number
}) =>
  numberOfVariantsWithSuggestedOrder < variantsLength && (
    <Alert>
      <p>
        <b>{numberOfVariantsWithSuggestedOrder}</b> variants have a suggested order out of the{" "}
        <b>{variantsLength}</b> selected variants.
      </p>
    </Alert>
  )
